import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { navItems } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    brand
  } = useBrand();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="bg-cream" data-id="element-177" data-mp="i0ssn4fdd7zr">
      <div className="hidden bg-ink text-cream md:block" data-id="element-178" data-mp="vqmerezhpe5s">
        <div className="mx-auto flex max-w-shell items-center justify-between px-8 py-2 text-[0.6875rem] uppercase tracking-label" data-id="element-179" data-mp="vs7b9a5d776a">
          <p className="text-cream/80" data-id="element-180" data-mp="qy31kj4psl1i">{brand.copy.utilityLeft}</p>
          <p className="text-copper" data-id="element-181" data-mp="38qxfxo8v362">{brand.copy.utilityRight}</p>
        </div>
      </div>

      <div className="border-b border-ink/10" data-id="element-182" data-mp="3ufv1qkt08bas">
        <div className="mx-auto flex max-w-shell items-center justify-between px-6 py-4 md:px-8" data-id="element-183" data-mp="6vomptrb2x3a">
          <Link to="/" className="text-ink" aria-label={`${brand.name} home`} data-id="element-184" data-mp="burtbimxpbdd">
            <Logo className="text-base md:text-lg" markClassName="text-brick" data-id="element-185" data-mp="bsoss4o5nzue" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-186" data-mp="gnkxo5ehqhox">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-150 ease-republic ${isActive ? 'text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-187" data-mp="3k2gmnh1x9mrt">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-5 lg:flex" data-id="element-188" data-mp="19aox7uute3tb">
            <Link to="/pricing" className="text-sm text-ink-muted transition-colors duration-150 ease-republic hover:text-ink" data-id="element-189" data-mp="19ci49b9caq1u">
              Sign in
            </Link>
            <Link to="/get-started" className="rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-cream transition-colors duration-150 ease-republic hover:bg-ink-soft" data-id="element-190" data-mp="35daggli2ta2i">
              Get started
            </Link>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-191" data-mp="3ebvuc3cls0wy">
            {open ? <XIcon className="h-6 w-6" data-id="element-192" data-mp="30egyafruguw0" /> : <MenuIcon className="h-6 w-6" data-id="element-193" data-mp="30fs74u05cstz" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-194" data-mp="2vmp9oas90z8i">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-ink/10 bg-cream lg:hidden" data-id="element-195" data-mp="27xwissqhhhkr">
            <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-6" data-id="element-196" data-mp="n793h2wn86aj">
              <ul className="flex flex-col" data-id="element-197" data-mp="9g2umg7h4waz">
                {navItems.map(item => <li key={item.to} className="border-b border-ink/10" data-id="element-198" data-mp="9e9kus1kdvyr">
                    <Link to={item.to} className="block py-4 font-serif text-xl font-semibold text-ink" data-id="element-199" data-mp="efp54hvx3yg3">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/get-started" className="mt-6 inline-flex rounded-full bg-ink px-6 py-3 text-sm font-medium text-cream" data-id="element-200" data-mp="1640slsyv9fmi">
                Get started
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}